<div class="row">
  <div class="col-md-12">
    <div class="col-md-12 col-xs-12 vh-100">
      <ag-grid-angular
        class="ag-theme-alpine"
        [gridOptions]="gridOptions"
        (gridReady)="gridSetting($event)"
        (firstDataRendered)="restoreGridState($event)"
        (paginationChanged)="saveGridState($event)"
        (sortChanged)="saveGridState($event)"
        [columnDefs]="columnDefs"
        [rowData]="_crews"
        [domLayout]="'autoHeight'"
        [pagination]="true"
        [paginationPageSize]="10"
        [paginationPageSizeSelector]="[10,20,30]"
        [enableCellTextSelection]="true">
      </ag-grid-angular>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="appraisalModal"
  tabindex="-1"
  aria-hidden="true"
  [class.show]="appraisal"
  >
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ selectedCrew?.firstName }} {{ selectedCrew?.lastName }}- Appraisal submitted on {{ appraisal?.date }}
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="appraisal = null">
        </button>
      </div>

      <div class="modal-body">
        <table class="table table-sm table-striped table-bordered">
          <thead>
            <tr>
              <th>Item</th>
              <th>Grade</th>
              <th>Remark</th>
            </tr>
          </thead>

          <tbody>
            @for (item of appraisal?.appraisals || []; track $index) {
              <tr>
                <td>{{ item.item }}</td>
                <td>{{ item.grade?.toUpperCase() }}</td>
                <td>{{ item.remark }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>